<template>
    <div>
        <div class="row shadow-div padding-div">
      
            <div class="col-sm-5 col-lg-5">
                <div class="row">
                    <div class = "col-sm-6 col-lg-6">
                        <div class="h6" style="color: dimgrey;">Attendance</div>
                        <hr/>
                        <p style="color: dimgrey;">Active Members</p>
                        <div class = "row">
        
                            <div class = "col-md-6 col-txt-center"> 
                
                                <div class="card shadow-div">
                                    <div class="card-block dashboard-card-blk">
                                        <div style="font-weight: bold;color:  rgb(156, 154, 154)">{{this.DashboardAttendance.today > 0 ? this.DashboardAttendance.today : 0}}</div>
                                    </div>
                                </div>
                                <small class="text-muted">Today</small>
                            </div>
                            <div class = "col-md-6 col-txt-center"> 
            
                                <div class="card shadow-div">
                                    <div class="card-block dashboard-card-blk">
                                        <div style="font-weight: bold;color:  rgb(156, 154, 154)">{{this.DashboardAttendance.weeklyAvg > 0 ? this.DashboardAttendance.weeklyAvg : 0}}</div>
                                    </div>
                                </div>
                                <small class="text-muted">Weekly.</small>
                            </div>
                        </div>
                
                    </div>

                    <div class = "col-sm-6 col-lg-6">
                        <div class="h6" style="color: dimgrey;">Activity</div>
                        <hr/>
                        <p style="color: dimgrey;">Members Activity</p>
                        <div class = "row">   
                            <div class = "col-md-6 col-txt-center"> 
                                <div class="card shadow-div">
                                    <div class="card-block dashboard-card-blk">
                                        <div style="font-weight: bold;color:  rgb(156, 154, 154)">{{this.DashboardActivity.Today > 0 ?  DashboardActivity.weeklyAvg : 0}}%</div>
                                    </div>
                                </div>
                                <small class="text-muted">Today</small>
                            </div>

                            <div class = "col-md-6 col-txt-center">
                                <div class="card shadow-div">
                                    <div class="card-block dashboard-card-blk">
                                        <div style="font-weight: bold;color:  rgb(156, 154, 154)">{{DashboardActivity.weeklyAvg > 0 ? DashboardActivity.weeklyAvg : 0}}%</div>
                                    </div>
                                </div>
                                <small class="text-muted">Weekly</small>
                            </div>
                        </div>
                
                    </div>

                </div>
            </div>
    <div class="col-sm-2 col-lg-2"></div>
    <!--/.col-->
    <div class="col-sm-5 col-lg-5">
        <div class="row">
        <div class = "col-sm-6 col-lg-6">
          <div class="h6" style="color: dimgrey;">Hours</div>
          <hr/>
          <p style="color: dimgrey;">Logged Members Hours</p>
        <div class = "row">
        
            <div class = "col-md-6 col-txt-center"> 
              
              <div class="card shadow-div">
                <div class="card-block dashboard-card-blk">
                  <div style="font-weight: bold;color:  rgb(156, 154, 154)">{{DashboardHours.Today > 0 ?  DashboardHours.Today: 0}}</div>
                </div>
              </div>
              <small class="text-muted">Today</small>
            </div>
            <div class = "col-md-6 col-txt-center"> 
            
              <div class="card shadow-div">
                  <div class="card-block dashboard-card-blk">
                    <div style="font-weight: bold;color:  rgb(156, 154, 154)">{{DashboardHours.weeklyAvg > 0 ?  DashboardHours.weeklyAvg :0 }}</div>
                  </div>
                </div>
                <small class="text-muted">Weekly</small>
            </div>
        </div>
              
        </div>
    
        <div class = "col-sm-6 col-lg-6">
            <div class="h6" style="color: dimgrey;">Avg.Hours/Day</div>
            <hr/>
            <p style="color: dimgrey;">Logged Members Hours</p>
            <div class = "row">
            
                <div class = "col-md-6 col-txt-center"> 
                
                    <div class="card shadow-div">
                    <div class="card-block dashboard-card-blk">
                        <div style="font-weight: bold;color:  rgb(156, 154, 154)">{{DashboardHours.Today > 0 ? DashboardHours.Today : 0}}%</div>
                    </div>
                    </div>
                    <small class="text-muted">Yesterday</small>
                </div>
                <div class = "col-md-6 col-txt-center"> 
                
                    <div class="card shadow-div">
                        <div class="card-block dashboard-card-blk">
                        <div style="font-weight: bold;color:  rgb(156, 154, 154)">{{DashboardHours.weeklyAvg > 0 ? DashboardHours.weeklyAvg : 0}}%</div>
                        </div>
                    </div>
                    <small class="text-muted">Weekly.</small>
                </div>
            </div>
                
        </div>
    
        </div>
      </div>
  </div>
  <!--SPINNER-->
    
      <Spinner class = "spinner" v-if="isLoading" message="Loading..." size="medium" 
        line-fg-color="rgb(222 224 219" 
        line-bg-color="rgb(68 66 62)">
      </Spinner>
    <!--/SPINNER-->	
   
    <Toaster ref = "toaster"/>
    </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner';
import Toaster from './toaster'
export default {

    name: 'Dashboard',
    components:{
        Toaster,
        Spinner
    },
    data(){
        return {
            dashboardData:null,
            isLoading:true,

        }
    },

    created(){
        this.getDashboard();
    },

    methods:{

        getDashboard()
        {

          this.isLoading = true;

          axios.get('/Dashboard/getData/'+this.$auth.user().companyId)

         .then(res=>{

            if(res.data.status == 1)
            {
                this.dashboardData = res.data.data;
            }
            else
            {
                this.$refs.toaster.showToast('Error','danger',res.data.msg)
            }

            })
            .catch((err) => {
                console.warn('error during http call', err);
            })
        }
    }
}
</script>